import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const LoaderContainer = styled.div`
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: ease-in-out .3s;
  position: absolute;
  width: 100%;
  z-index: 999;
  background: ${colors.bgOverlay};
`;

export const LoaderContent = styled.div`
  padding: 30px 10px;
  width: 100%;
  max-width: 255px;
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const LoaderImage = styled.img`
  width: 62px;
`;

export const LoaderText = styled.h6`
  font-size: 16px;
  line-height: 20px;
  color: ${colors.bgPrimary};
  margin-top: 20px;
`;
